<!-- ============================================================ -->
<!-- DESKTOP VIEW (md y superior) -->
<!-- ============================================================ -->
<div class="hidden md:block p-6 min-h-screen font-sans" style="zoom: 0.9">
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
    <h3 class="font-bold text-[#0D171C]">{{ 'AbpSettingManagement::Settings' | abpLocalization }}</h3>
  </div>

  <!-- Tabs -->
  <div class="flex border-b border-gray-200 mb-6">
    @for (setting of visibleSettings(); track setting.name) {
    <button (click)="selectTab(setting)"
      [ngClass]="isTabSelected(setting) ? 'border-metro-blue text-metro-blue font-semibold' : 'border-transparent text-gray-500 hover:text-gray-700'"
      class="py-2 px-6 border-b-2 font-medium text-sm transition-all duration-300">
      {{ setting.name | abpLocalization }}
    </button>
    }
  </div>

  <!-- Content Area -->
  <div class="w-full bg-white rounded-2xl border border-gray-200 p-6 shadow-sm">
    @if (isPaymentTab) {
      <div class="font-sans text-[#0D171C]">
        <div class="mb-5">
          <h4 class="text-base font-bold mb-1">{{ '::PaymentGatewaySettings' | abpLocalization }}</h4>
          <p class="text-sm text-gray-500">{{ '::SelectPaymentProviderDescription' | abpLocalization }}</p>
        </div>

        @if (loading()) {
          <div class="flex items-center gap-3 py-8 text-gray-400 text-sm">
            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-600"></div>
            {{ '::Loading' | abpLocalization }}
          </div>
        } @else {
          <div class="max-w-md mb-6">
            <app-metro-form-select
              [label]="'::ActiveProvider' | abpLocalization"
              [placeholder]="'::SelectProviderPlaceholder' | abpLocalization"
              [options]="providerOptions"
              [allowSearch]="false"
              [allowClear]="false"
              [(ngModel)]="selectedProvider">
            </app-metro-form-select>

            @if (selectedProvider === 'Payway') {
              <app-metro-form-input
                [label]="'::MinimumAmountForInstallments' | abpLocalization"
                type="number"
                [(ngModel)]="minimumAmountForInstallments">
              </app-metro-form-input>
            }
          </div>

          <div class="flex gap-3">
            <button (click)="savePaymentSettings()"
                    [disabled]="saving()"
                    class="px-6 py-2.5 rounded-xl text-sm font-semibold text-white bg-[#1C2D36] hover:bg-[#0D171C] disabled:opacity-50 transition-all flex items-center gap-2">
              @if (saving()) {
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                {{ '::Saving' | abpLocalization }}
              } @else {
                {{ '::SaveChanges' | abpLocalization }}
              }
            </button>
            <button (click)="loadPaymentSettings()"
                    [disabled]="saving()"
                    class="px-5 py-2.5 rounded-xl border border-gray-300 text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 transition-all">
              {{ '::Cancel' | abpLocalization }}
            </button>
          </div>
        }
      </div>
    } @else if (selectedTab()) {
      <ng-container *ngComponentOutlet="selectedTab()!.component"></ng-container>
    } @else {
      <div class="py-16 text-center text-gray-400 text-sm">
        {{ 'AbpSettingManagement::SelectSettingToView' | abpLocalization }}
      </div>
    }
  </div>
</div>

<!-- ============================================================ -->
<!-- MOBILE VIEW (menos de md) -->
<!-- ============================================================ -->
<div class="md:hidden min-h-screen px-4 pt-6 pb-24 overflow-x-hidden font-sans" style="zoom: 0.9">
  <!-- Header -->
  <div class="mb-5">
    <h3 class="font-bold mb-2 text-[#0D171C]">{{ 'AbpSettingManagement::Settings' | abpLocalization }}</h3>
  </div>

  <!-- Tabs -->
  <div class="flex border-b border-gray-200 mb-5 overflow-x-auto no-scrollbar whitespace-nowrap">
    @for (setting of visibleSettings(); track setting.name) {
    <button (click)="selectTab(setting)"
      [ngClass]="isTabSelected(setting) ? 'border-b-2 border-gray-900 text-gray-900 font-semibold' : 'text-gray-400 font-medium'"
      class="py-2 pr-6 text-sm transition-all whitespace-nowrap">
      {{ setting.name | abpLocalization }}
    </button>
    }
  </div>

  <!-- Content Area -->
  <div class="w-full bg-white rounded-2xl border border-gray-200 p-4 shadow-sm">
    @if (isPaymentTab) {
      <div class="font-sans text-[#0D171C]">
        <div class="mb-5">
          <h4 class="text-base font-bold mb-1">{{ '::PaymentGatewaySettings' | abpLocalization }}</h4>
          <p class="text-sm text-gray-500">{{ '::SelectPaymentProviderDescription' | abpLocalization }}</p>
        </div>

        @if (loading()) {
          <div class="flex items-center gap-3 py-8 text-gray-400 text-sm">
            <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-600"></div>
            {{ '::Loading' | abpLocalization }}
          </div>
        } @else {
          <div class="max-w-md mb-6">
            <app-metro-form-select
              [label]="'::ActiveProvider' | abpLocalization"
              [placeholder]="'::SelectProviderPlaceholder' | abpLocalization"
              [options]="providerOptions"
              [allowSearch]="false"
              [allowClear]="false"
              [(ngModel)]="selectedProvider">
            </app-metro-form-select>

            @if (selectedProvider === 'Payway') {
              <app-metro-form-input
                [label]="'::MinimumAmountForInstallments' | abpLocalization"
                type="number"
                [(ngModel)]="minimumAmountForInstallments">
              </app-metro-form-input>
            }
          </div>

          <div class="flex gap-3">
            <button (click)="savePaymentSettings()"
                    [disabled]="saving()"
                    class="px-6 py-2.5 rounded-xl text-sm font-semibold text-white bg-[#1C2D36] hover:bg-[#0D171C] disabled:opacity-50 transition-all flex items-center gap-2">
              @if (saving()) {
                <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                {{ '::Saving' | abpLocalization }}
              } @else {
                {{ '::SaveChanges' | abpLocalization }}
              }
            </button>
            <button (click)="loadPaymentSettings()"
                    [disabled]="saving()"
                    class="px-5 py-2.5 rounded-xl border border-gray-300 text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 transition-all">
              {{ '::Cancel' | abpLocalization }}
            </button>
          </div>
        }
      </div>
    } @else if (selectedTab()) {
      <ng-container *ngComponentOutlet="selectedTab()!.component"></ng-container>
    } @else {
      <div class="py-12 text-center text-gray-400 text-sm">
        {{ 'AbpSettingManagement::SelectSettingToView' | abpLocalization }}
      </div>
    }
  </div>
</div>
